// frontend/src/components/support/SupportChatWidget.jsx
import React, { useMemo, useState } from "react";
import { MessageCircleQuestion } from "lucide-react";
import { useLocation } from "react-router-dom";
import SupportChatDrawer from "./SupportChatDrawer";

function inferModuleFromRoute(pathname) {
  const path = pathname || "";

  if (path.startsWith("/agenda")) return "agenda";
  if (path.includes("/agendamentos")) return "agenda";
  if (path.startsWith("/anamnese")) return "anamnese";
  if (path.startsWith("/configuracoes")) return "configuracoes";
  if (path.startsWith("/prontuarios")) return "prontuarios";
  if (path.includes("/prontuario")) return "prontuarios";
  if (path.startsWith("/ia")) return "ia";
  if (path.startsWith("/cobranca")) return "billing";
  if (path.startsWith("/estoque")) return "inventory";
  if (path.startsWith("/lembretes")) return "reminders";
  if (path.startsWith("/conformidade")) return "compliance";

  return "";
}

function inferTitleFromRoute(pathname) {
  const path = pathname || "";

  if (path.startsWith("/agenda")) return "Agenda";
  if (path.includes("/agendamentos")) return "Agendamentos do Prontuário";
  if (path.startsWith("/anamnese")) return "Anamnese";
  if (path.startsWith("/configuracoes")) return "Configurações";
  if (path.startsWith("/prontuarios")) return "Prontuários";
  if (path.includes("/prontuario")) return "Prontuário do Paciente";
  if (path.startsWith("/ia")) return "Assistente Técnico";
  if (path.startsWith("/cobranca")) return "Cobrança";
  if (path.startsWith("/estoque")) return "Estoque";
  if (path.startsWith("/lembretes")) return "Lembretes";
  if (path.startsWith("/conformidade")) return "Boas Práticas";

  return "Tela atual";
}

export default function SupportChatWidget() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const currentRoute = location.pathname;

  const currentTab =
    localStorage.getItem("support_active_tab") || "";

  const currentModule = useMemo(() => {
    if (currentTab === "appointments") return "agenda";
    if (currentTab === "odontogram") return "prontuarios";
    if (currentTab === "images") return "imagens";
    if (currentTab === "anamnese") return "anamnese";

    return inferModuleFromRoute(currentRoute);
  }, [currentRoute, currentTab]);

  const pageTitle = useMemo(() => {
    if (currentTab === "appointments")
      return "Agendamentos do Prontuário";

    if (currentTab === "odontogram")
      return "Odontograma";

    if (currentTab === "images")
      return "Imagens do Paciente";

    if (currentTab === "anamnese")
      return "Anamnese";

    return inferTitleFromRoute(currentRoute);
  }, [currentRoute, currentTab]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-indigo-600 text-white shadow-xl hover:bg-indigo-700 flex items-center justify-center"
        aria-label="Abrir suporte"
        title="Abrir suporte"
      >
        <MessageCircleQuestion size={24} />
      </button>

      <SupportChatDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
        currentRoute={currentRoute}
        currentModule={currentModule}
        pageTitle={pageTitle}
      />
    </>
  );
}
